import ShowroomPopoverMenu from "./showroom-popover-menu";

export default ShowroomPopoverMenu;